import React from 'react';
import CWTextField from './CWTextField';
import { InputProps } from './types';

const CWNumberField: React.FC<InputProps> = (props) => {
  const { field, float } = props;
  return <CWTextField field={field} float={float} />;
};

export default CWNumberField;
